import history from "./history";
import { applyMiddleware, compose, createStore } from "redux";
import axios from "axios";
import axiosMiddleware from "redux-axios-middleware";

import { routerMiddleware } from "connected-react-router";
import createRootReducer from "./reducers/rootReducer";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web and AsyncStorage for react-native
import thunk from "redux-thunk";
import { baseUrl } from "./actions/utils";

const initialState = {};

const rootReducer = createRootReducer(history);

const client = axios.create({
    baseURL: baseUrl,
    responseType: "json",
});
const options = {
    returnRejectedPromiseOnError: true,
    interceptors: {
        request: [
            ({}, config) => {
                // Add authentication tokens to request header
                const bearer = localStorage.getItem("bearer");
                config.headers.bearer = bearer;
                return config;
            },
        ],
        response: [],
    },
};
const persistConfig = {
    key: "sopia_root",
    storage,
    blacklist: [
        "login",
        "verification",
        "passwordreset",
        "propertyReducer",
        "usersReducer",
    ],
};
const composeEnhancers =
    process.env.NODE_ENV === "development"
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
        : compose;
const persistedReducer = persistReducer(persistConfig, rootReducer);
let middleware = [
    routerMiddleware(history),
    thunk,
    axiosMiddleware(client, options),
];

export const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware))
);

export const persistor = persistStore(store);
